<template>
  <div v-if="selectedVehicle">
    <div class="modal fade" role="dialog" ref="vehiclepoolmodal">
      <div class="modal-dialog modal-lg">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header modal-new" :class="{ update: isUpdate }">
            <div class="row">
              <div class="col-sm-10">
                <h4>
                  Vehicle Pool ({{ selectedVehicle.factoryName }}
                  {{ selectedVehicle.brandName }})
                </h4>
                <h6 v-if="model.modifiedDate">
                  Last Updated: {{ model.modifiedDate.stringFullDate }}
                </h6>
              </div>
              <div class="col-sm-2">
                <button
                  type="button"
                  class="close"
                  data-dismiss="modal"
                  aria-label="Close"
                >
                  <i class="ic-close"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-body">
            <div class="modal-wrapper modal-detail">
              <div class="col-sm-12">
                <div class="modal-content-body">
                  <div class="row">
                    <div class="col-sm-12">
                      <div class="row">
                        <!-- Start: Form -->
                        <div class="col-sm-3 divider-right pr-25">
                          <div class="summary-error" v-if="$v.model.$error">
                            This form has errors
                          </div>
                          <form @submit.prevent="submit">
                            <div class="form-group">
                              <label class="required">Pool</label>
                              <v-select
                                class="v-search-select"
                                :class="{
                                  'field-error': isSubmitted && $v.model.poolId.$error,
                                }"
                                placeholder=""
                                label="label"
                                v-model="model.poolId"
                                :options="pools"
                                :clearable="true"
                                :searchable="true"
                                :filterable="true"
                                :reduce="(option) => option.id"
                                :disabled="isViewOnly"
                              ></v-select>
                              <small
                                class="form-text sts-danger"
                                v-if="isSubmitted && !$v.model.poolId.required"
                                >Pool is required</small
                              >
                            </div>
                            <div
                              class="modal-footer"
                              v-if="!isViewOnly && (isAllowToCreate || isAllowToUpdate)"
                            >
                              <button
                                v-if="isAllowToCreate || isAllowToUpdate"
                                type="button"
                                class="btn btn-default"
                                @click.prevent="reset()"
                              >
                                Reset
                              </button>
                              <button
                                v-if="!isUpdate && isAllowToCreate"
                                type="submit"
                                class="btn btn-primary"
                              >
                                Create
                              </button>
                              <button
                                v-if="isUpdate && isAllowToUpdate"
                                type="submit"
                                class="btn btn-primary"
                              >
                                Update
                              </button>
                            </div>
                          </form>
                        </div>
                        <!-- End: Form -->
                        <!-- Start: Table -->
                        <div class="col-sm-9 divider-left pl-20">
                          <div class="table-modal-detail">
                            <div class="table-responsive">
                              <table class="table table-hover table-fix mtz">
                                <thead>
                                  <tr>
                                    <th class="number">No</th>
                                    <th>Location</th>
                                    <th class="text-center">Status</th>
                                    <th class="text-center" v-if="!isViewOnly">Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(item, index) in items" :key="item.id">
                                    <td class="text-center">{{ index + 1 }}</td>
                                    <td>{{ item.location.name }}</td>
                                    <td class="text-center">
                                      <label class="cursor-pointer">
                                        <input
                                          type="checkbox"
                                          class="control-checkbox"
                                          v-model="item.isActive"
                                          :disabled="isViewOnly || !isAllowToUpdate"
                                          @change="changeStatus(item)"
                                        />
                                        <span class="pl-5 font-weight-normal v-align-middle">
                                          {{ item.isActive ? "Active" : "Inactive" }}
                                        </span>
                                      </label>
                                    </td>
                                    <td class="text-center" v-if="!isViewOnly">
                                      <div class="button-action-wrapper">
                                        <button
                                          v-if="isAllowToUpdate"
                                          class="btn btn-default"
                                          type="button"
                                          @click="bindModel(item)"
                                        >
                                          <span>Edit</span>
                                        </button>
                                        <button
                                          v-if="isAllowToDelete"
                                          class="btn btn-default"
                                          type="button"
                                          @click="confirmDelete(item)"
                                        >
                                          <i class="ic-close"></i>
                                        </button>
                                      </div>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                        <!-- End: Table -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- /.modal-wrapper -->
          </div>
          <!-- /.modal-body -->
        </div>
        <!-- /.modal-content -->
      </div>
    </div>

    <!-- Start: BlockUI -->
    <loader :content="msg" :visible="isLoading" />
    <!-- End: BlockUI -->
  </div>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import poolService from "@/services/master/pool/poolService.js";
import vehiclePoolService from "@/services/master/vehicle/vehiclePoolService.js";

export default {
  computed: {
    isAllowToRead: function () {
      return this.allPermissions.includes("Read");
    },
    isAllowToCreate: function () {
      return this.allPermissions.includes("Create");
    },
    isAllowToUpdate: function () {
      return this.allPermissions.includes("Update");
    },
    isAllowToDelete: function () {
      return this.allPermissions.includes("Delete");
    },
  },
  data() {
    return {
      isSubmitted: false,
      allPermissions: [],
      isViewOnly: false,
      selectedVehicle: null,
      pools: [],
      items: [],
      model: {},
      isUpdate: false,
      isLoading: false,
      msg: "Please wait",
    };
  },
  validations() {
    return {
      model: {
        poolId: { required },
      },
    };
  },
  created() {
    // subscribe message
    this.$eventBus.$on("initializeVehiclePool", this.initialize);
    this.$eventBus.$on("deleteVehiclePool", this.deleteItem);
    this.$eventBus.$on("openModalVehiclePool", this.openModal);
  },
  beforeDestroy() {
    this.$eventBus.$off("initializeVehiclePool");
    this.$eventBus.$off("deleteVehiclePool");
    this.$eventBus.$off("openModalVehiclePool");
    this.closeModal();
  },
  methods: {
    openModal() {
      $(this.$refs.vehiclepoolmodal).modal({ backdrop: "static", keyboard: false });
      $(this.$refs.vehiclepoolmodal).css("overflow-y", "auto");
    },
    closeModal() {
      $(this.$refs.vehiclepoolmodal).modal("hide");
    },
    async initialize(vehicle) {
      try {
        this.isLoading = true;
        this.isViewOnly = !vehicle.isOwnInventory;
        this.reset();
        this.selectedVehicle = vehicle;

        const profile = await this.$store.dispatch("user/getProfile");
        const permissions = profile.services["VehiclePool"];
        if (permissions) {
          this.allPermissions = permissions;
        }

        if (this.isAllowToRead) {
          await this.getAll();
          this.getPools();
        }

        this.openModal();
      } finally {
        this.isLoading = false;
      }
    },
    bindModel(object) {
      this.isUpdate = true;
      this.model = Object.assign({}, object);
    },
    reset() {
      this.isUpdate = false;
      this.isSubmitted = false;
      this.$v.model.$reset();
      this.model = {};
    },
    async getAll() {
      this.items = await vehiclePoolService.getAll(this.selectedVehicle.id);
    },
    async getPools() {
      this.pools = await poolService.getAllByVehicleId(this.selectedVehicle.id);

      for (let i = 0; i < this.pools.length; i++) {
        const pool = this.pools[i];
        pool.label = pool.location.name;
      }
    },
    async submit() {
      this.isSubmitted = true;
      this.$v.model.$touch();
      if (this.$v.model.$error) {
        return;
      }
      try {
        this.isLoading = true;
        this.model.vehicleId = this.selectedVehicle.id;
        if (!this.isUpdate) {
          await vehiclePoolService.create(this.model);
          this.$notification.success("Successfully added.", { title: "Success" });
        } else {
          await vehiclePoolService.update(this.model);
          this.$notification.success("Successfully updated.", { title: "Success" });
        }
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    async changeStatus(item) {
      try {
        this.isLoading = true;
        await vehiclePoolService.update(item);
        this.$notification.success("Successfully updated.", { title: "Success" });
        this.reset();
        await this.getAll();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
    confirmDelete(item) {
      this.closeModal();
      this.$eventBus.$emit("openVehicleDeleteModal", "vehiclePool", item.id);
    },
    async deleteItem(id) {
      try {
        this.isLoading = true;
        await vehiclePoolService.delete(id);
        this.$notification.success("Successfully deleted.", { title: "Success" });
        this.reset();
        await this.getAll();
        this.openModal();
      } catch (error) {
        if (error.errors) {
          for (let index = 0; index < error.errors.length; index++) {
            this.$notification.error(error.errors[index], { title: "Error" });
          }
        }
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/master/vehicle/VehiclePool.vue